import { PriceFromStripe } from "../interfaces/apiRequests/PriceFromStripe";
import { RedirectPaymentPage } from "../interfaces/payment/RedirectPaymentPage";
import { Listing } from "../interfaces/training-plan/Listing";
import { IUserData } from "../interfaces/user/IUserData";
import { fetcher } from "../lib/fetcher";
import * as Sentry from "@sentry/nextjs";

export async function getStripePrices() {
  return fetcher("subscriptions/prices").catch((error: Error) => {
    throw error;
  }) as Promise<PriceFromStripe[]>;
}

export async function createSubscription(
  subscriptionPlanId: number,
  user: IUserData,
  listing?: Listing
) {
  return fetcher("subscriptions/create", {
    method: "POST",
    headers: {
      authorization: `Bearer ${user.token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      subscriptionPlanId: subscriptionPlanId,
      paymentProvider: "stripe",
      deviceOs: "web",
      trainingPlanId: listing ? listing.id : null,
      trainingPlanName: listing ? listing.title : null,
      analyticsUserId: `${user.id}`,
    }),
  }).catch((error: Error) => {
    throw error;
  }) as Promise<RedirectPaymentPage>;
}

export async function updateSubscription(user: IUserData) {
  return fetcher("subscriptions/update", {
    method: "POST",
    headers: {
      authorization: `Bearer ${user.token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      paymentProvider: "stripe",
      deviceOs: "web",
    }),
  }).catch((error: Error) => {
    throw error;
  }) as Promise<RedirectPaymentPage>;
}

export async function createSubscriptionOneToOne(
  user: IUserData,
  coachData: IUserData,
  listing?: Listing
) {
  return fetcher("subscriptions/create/one-to-one", {
    method: "POST",
    headers: {
      authorization: `Bearer ${user.token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      coachId: coachData.id,
      deviceOs: "web",
      trainingPlanId: listing ? listing.id : null,
      trainingPlanName: listing ? listing.title : null,
    }),
  }).catch((error: Error) => {
    throw error;
  }) as Promise<RedirectPaymentPage>;
}
